import React, {Component} from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import {Grid, Typography} from "@material-ui/core";
import ItemAward from "./ItemAward";
import SpacerComponent
    from "../../../Components/SpacerComponent/SpacerComponent";

class ContentListAward extends Component {

    makeItemAward() {

        let itens = [];
        const context = this;

        this.props.awards.forEach(function (value, index) {

            if (context.props.isCampaing) {
                if (/*value.products !== undefined && */value.object_type !== 'campaign') {
                    return;
                }
            }

            if (!context.props.isCampaing) {
                if (/*value.products !== undefined && */value.object_type === 'campaign') {
                    return;
                }
            }
            itens.push(
                <ItemAward award={value}
                           setAwardsEnabledDisabled={context.props?.setAwardsEnabledDisabled ?? null}
                           selectAward={context.props?.selectAward ?? null}
                           removeStatus={context.props.removeStatus}
                           inModal={context.props.inModal}
                           onSelectAwardInModal={context.props.onSelectAwardInModal} // Pass the new prop
                />
            );
        });

        return itens;
    }

    render() {

        if ((this.props?.awards?.length ?? 0) === 0) {
            return (
                <div>
                    <SpacerComponent height={100}/>
                    <Typography align={'center'}
                                variant={'subtitle2'}
                                color={'primary'}>
                        {this.props.emptyListText}
                        <SpacerComponent height={265}/>
                    </Typography>
                </div>
            );
        }

        return (
            <Grid container={true}
                  spacing={3}>
                {this.makeItemAward()}
            </Grid>
        );
    }
}

ContentListAward.propTypes = {
    awards: PropTypes.array.isRequired,
    isCampaing: PropTypes.bool,
    setAwardsEnabledDisabled: PropTypes.func,
    selectAward: PropTypes.func,
    removeStatus: PropTypes.bool,
    emptyListText: PropTypes.string,
    inModal: PropTypes.bool,
    onSelectAwardInModal: PropTypes.func, // Added onSelectAwardInModal propType
};

export default ContentListAward;